
import { Radar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Radar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options || {
      tooltips: {
        enabled: false
      },
      hover: {
        mode: null
      },
      legend: {
        display: false
      },
      responsive: true,
      scale: {
        gridLines: {
          display: false
        },
        pointLabels: {
          fontSize: 17,
          fontStyle: 300,
          fontColor: "#2c302e",
          fontFamily: "museo-slab"
        },
        ticks: {
          beginAtZero: true,
          max: 100,
          display: false
        }
      }
    });
  }
};
